"use strict";
/**
 * 去除屏幕焦点
 *
 * ### Example
 * ```
 * triggerBlur();
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function triggerBlur() {
    var active = document.activeElement;
    active && active.blur && active.blur();
}
exports.triggerBlur = triggerBlur;
